import React from 'react';
import PropTypes from 'prop-types';
import { FooterWrapper } from './Footer.styled';

const Footer = () => (
  <FooterWrapper>
    <p>
      Contact us at{' '}
      <a
        href="https://evalcertification.org/contact/"
        target="_blank"
        rel="noreferrer"
      >
        Workplace Charging
      </a>
      .
    </p>
  </FooterWrapper>
);

export default Footer;
